export default "__VITE_PUBLIC_ASSET__682eaa4a__"